<template>
<div class="col-10 ms-auto mb-6"  >
  <h3 class="page-title">Gendec Airport Management</h3>
  <div class="delete-status alert" role="alert">
  </div>
  <div class="airport-status alert" role="alert">
  </div>
  <div class="add-status alert" role="alert">
  </div>

  <div  v-permcheck="'GendecAirportManagament.AirportManagementGrid.R'"  class="add-area row justify-content-start" >
    <div class="row">
      <div class="row d-flex justify-content-start">
        <div class="col-md-6 text-start">
          <input v-model="manuelAirport" class="p-2 me-3" type="text" required maxlength="4" minlength="3" placeholder="Airport">
<!--          v-permcheck="'GendecAirportManagament.AirportManagementGrid.W'"-->
          <button  @click="addAirport" class="core-add-btn p-2 mb-1 rounded-1">Add</button>
        </div>
        <div class="col-md-2 text-end airport-info">
          {{this.selectedIATA}}
        </div>
      </div>
    </div>

  </div>
  <br>

  <div v-permcheck="'GendecAirportManagament.AirportManagementGrid.R'" class="row" >
    <div class="col-md-2 row flex-column">
      <button @click="fillMailDetails(item)" class="core-update-btn mb-2" :id="item.ARR" v-for="(item,index) in getList" :key="index">{{item.ARR}}</button>
    </div>
    <div class="col-md-10">
      <table style="width: 800px;font-family: NunitoBold" border="1" class="table table-bordered table-striped table-scroll core-table table-hover">
        <thead>
        <th style="font-size: 16px; font-weight: bold; border-bottom: 1px solid black">Airport</th>
        <th style="font-size: 16px; font-weight: bold; border-bottom: 1px solid black">Email</th>
        <th align="end" style="font-size: 16px; font-weight: bold;border-bottom: 1px solid black">Action</th>
        </thead>
        <tr v-for="(item, index) in mailDetailList.MAIL_LIST" :key="index" style="height: 40px">
          <td style="border-top: 1px solid black">{{AirportName}}</td>
          <td style="border-top: 1px solid black">{{item.MAIL}}</td>
          <td align="end" style="border-top: 1px solid black; "><button @click="deleteMail(item)" style="background-color: #d51317" class="core-close-btn rounded-1">Delete</button></td>
        </tr>
        <tr>
          <td style="border-top: 1px solid black;" colspan="2"><input v-model="newMail" class="w-100 border-0" type="email" required placeholder="Enter an email"></td>
          <td colspan="1" align="end" style="border-top: 1px solid black;"><button @click="addMail(item)" style="width: 63px;background-color: #56759c" class="core-add-btn rounded-1">Add</button></td>
        </tr>
      </table>
      <small class="d-none" id="warning-element">Enter a valid email address</small>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import {GlobalFunctionAndStateMixin} from "../../utils/mixins.js";
export default {
  mixins: [GlobalFunctionAndStateMixin],
  name: "GendecAirportManagement",
  data(){
    return {
      getList: [],
      mailList: [],
      AirportName: '',
      newMail: '',
      selectedID : 0,
      manuelAirport : '',
      selectedIATA: '',
      airportForm: {
        ID: 0,
        ARR: '',
      },
      mailForm: {
        ID: 0,
        IDARR: 0,
        MAIL: ''
      }
    }
  },
  mounted() {
    this.getMailList()
  },
  computed: {
    mailDetailList(){
      return this.mailList;
    },
  },
  methods: {
    getMailList() {
      try {
        axios.get(process.env.VUE_APP_API_URL+'DAI/Arrival/GetAll')
            .then((response) => {
              console.log(response);
              this.getList = JSON.parse(response.data.jsondata);
              console.log(this.getList);
            })
      }
      catch (ex) {
        console.log(ex)
      }
    },
    addAirport(){
      try {
        let element = document.getElementsByClassName("airport-status")[0];
        this.airportForm.ID = 0;
        this.airportForm.ARR = this.manuelAirport;
        if(this.manuelAirport.length === 3 || this.manuelAirport.length === 4){
          axios.post(process.env.VUE_APP_API_URL+'DAI/Arrival/InsertOrUpdate', this.airportForm)
              .then((response) => {
                console.log(response);
                if(response.request.status === 200){
                  element.classList.add('alert-success');
                  element.innerHTML = "Aiport added successfully !";
                  element.classList.add('alert-block');
                }
                else {
                  element.classList.add('alert-danger');
                  element.innerHTML = "Error on adding airport !";
                  element.classList.add('alert-block');
                }
              })
          location.reload();
          this.getMailList();
        }
      }
      catch (ex) {
        console.log(ex)
      }
    },
    fillMailDetails(item){
      try {
        this.selectedIATA = item.ARR;
        this.AirportName = '';
        this.selectedID = -1;
        this.mailList = [];
        this.mailList = item;
        this.AirportName = item.AP_NAME;
        this.selectedID = item.ARRIVALID;
      }
      catch (ex) {
        console.log(ex)
      }
    },
    deleteMail(item){
      try {
        let id = item.MAILID;
        console.log(id);
        axios.post(process.env.VUE_APP_API_URL+'DAI/Mail/DeleteById?Id='+ id)
            .then((response) => {
              console.log(response);
              location.reload();
            })
      }
      catch (ex) {
        console.log(ex)
      }
    },
    addMail(){
      try {
        let warning = document.getElementById('warning-element');
        warning.classList.add('d-none');
        const regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
        this.mailForm.MAIL = this.newMail;
        this.mailForm.ID = 0;
        console.log(this.selectedID);
        this.mailForm.IDARR = this.selectedID;
        console.log(this.mailForm);
        if(this.mailForm.MAIL.match(regex)){
          axios.post(process.env.VUE_APP_API_URL+'DAI/Mail/InsertOrUpdate', this.mailForm)
              .then((response) => {
                console.log(response);
                location.reload();
              })
        }
        else warning.classList.remove('d-none');
        this.getMailList()
      }
      catch (ex) {
        console.log(ex)
      }
    }
  }
}
</script>

<style scoped>
.page-title{
  margin-top: 100px;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
.alert{
  display: none;
  position: fixed;
  top: 20px;
  right: 20px;
}
.alert-block{
  display: block;
  transition: all 2s linear;
}
#warning-element{
  color: #d51317;
  font-weight: bold;
}
.airport-info{
  font-size: 1.2rem;
  font-weight: 700;
  font-family: NunitoBold;
}
</style>
